import { Box } from '@chakra-ui/react';
import { ConnectWalletButton, LogoStatus, SimpleDisplayModalContent, SimpleModalHead, SimpleModalView } from '@cosmology-ui/react';
import React from 'react';
export const ErrorView = ({
  onClose,
  onReturn,
  wallet
}) => {
  const {
    walletInfo: {
      prettyName,
      logo
    },
    message
  } = wallet;
  const modalHead = /*#__PURE__*/React.createElement(SimpleModalHead, {
    title: prettyName,
    backButton: true,
    onClose: onClose,
    onBack: onReturn
  });
  const modalContent = /*#__PURE__*/React.createElement(SimpleDisplayModalContent, {
    status: LogoStatus.Error,
    logo: logo,
    contentHeader: 'Oops! Something wrong...',
    contentDesc: message,
    bottomButton: /*#__PURE__*/React.createElement(Box, {
      px: 6
    }, /*#__PURE__*/React.createElement(ConnectWalletButton, {
      buttonText: 'Change Wallet',
      onClick: onReturn
    }))
  });
  return /*#__PURE__*/React.createElement(SimpleModalView, {
    modalHead: modalHead,
    modalContent: modalContent
  });
};